/**
 * this file is for storing methods to communicate back and forth
 * between the webpage and native app (android & ios).
 */

import {runWebviewToAppBridge} from '~/common/utils/webview';

export function webViewOnNav(newStep, nextStep, prevStep, nextStepLabel) {
  runWebviewToAppBridge(
    'fabricCreateOnNav',
    newStep || '',
    nextStep || '',
    prevStep || '',
    nextStepLabel || ''
  );
}

export function webViewSetBusy(busy) {
  runWebviewToAppBridge('fabricCreateSetBusy', busy);
}

export function webViewSetEventId(eventId) {
  runWebviewToAppBridge('fabricCreateSetEventId', eventId);
}

export function webViewSetIsPremium(isPremium) {
  runWebviewToAppBridge('fabricCreateIsPremium', isPremium);
}
